import {
	Model,
	User
} from ".";

export default class Status extends Model {
	get singularNoun() {
		return "status";
	}

	get pluralNoun() {
		return "statuses";
	}

	get mutations() {
		return {
			userSetBy: User
		};
	}
}
